import { objectfyArray } from "../helpers/objectfyArray";

const cards = (state = {}, action) => {
  Object.freeze(state);
  let newState;
  switch (action.type) {
    case "SET_PUNCH_CARDS":
      if (Array.isArray(action.cards)) {
        return objectfyArray(action.cards);
      } else {
        // console.log(action.cards);
        return action.cards;
      }
    case "SET_PUNCH_CARD":
      return {
        ...state,
        [action.card.id]: action.card,
      };
    case "REMOVE_PUNCH_CARDS":
      return {};
    case "REMOVE_PUNCH_CARD":
      newState = {
        ...state,
      };
      delete newState[action.card.id];
      return newState;
    case "UPDATE_PUNCH_CARD":
      newState = {
        ...state,
      };
      newState[action.card.id] = action.card;
      return newState;
    case "REMOVE_PUNCH_CARDS":
      return {};
    case "ADD_TEMP_PUNCH_CARD":
      return {
        ...state,
        newCard: {
          id: "newCard",
          title: "",
          numberOfUses: null,
          maxDiscount: null,
          description: null,
          isPublic: true,
        },
      };
    case "UPDATE_TEMP_PUNCH_CARD":
      newState = { ...state };
      delete newState.newCard;
      return {
        ...newState,
        [action.card.id]: action.card,
      };
    case "REMOVE_PUNCH_CARD":
      newState = { ...state };
      delete newState[action.card.id];
      return newState;
    case "REMOVE_TEMP_PUNCH_CARD":
      newState = { ...state };
      delete newState["newCard"];
      return newState;
    default:
      return state;
  }
};

export default cards;
